import './styles/graphic.scss';
import { format } from 'd3-format';
import { wrapLongLabels } from './utils/helpers';

export default function (props, container, isMobile) {
  const {
    	colorScale,
    	data,
    	height,
    	initialHeight,
    	initialWidth,
    	margins,
    	// width,
    	x,
    	xAxis,
    	y,
  } = props;

  const [start, end] = x.domain();
  const radius = 3;
  const fmtSI = format('.2s');

  const starting = x(start) + x.bandwidth() / 2;
  const ending = x(end) + x.bandwidth() / 2;

  const svg = container.append('svg')
    .attr('width', initialWidth)
    .attr('height', initialHeight);

  const g = svg.append('g')
    .attr('transform', `translate(${[margins.left, margins.top]})`);

  const axisTop = g.append('g')
    .attr('class', 'x grid top')
    .call(xAxis(x));

  axisTop.selectAll('text')
    .attr('y', -15)
    .attr('dy', 0);

  const axisBottom = g.append('g')
    .attr('class', 'x grid bottom')
    .attr('transform', `translate(${[0, height]})`)
    .call(xAxis(x));

  axisBottom.selectAll('text')
    .attr('y', d => (isMobile ? 120 : 180));

  const group = g.append('g')
    .attr('class', 'data')
    .selectAll('g')
    .data(data)
    .enter()
    .append('g')
    // .style('fill', d => colorScale(d.label));
    .attr('fill', (d) => {
      if (d.change > 0) {
        return '#ff7c05';
      } if (d.change < 0) {
        return '#38ba79';
      }
      return '#cdcdcd';
    });


  group.append('line')
    .attr('class', 'line')
    .attr('x1', starting)
    .attr('x2', ending)
    .attr('y1', d => y(d.start))
    .attr('y2', d => y(d.end))
    // .style('stroke', d => colorScale(d.label));
    .style('stroke', (d) => {
      if (d.change > 0) {
        return '#ff7c05';
      } if (d.change < 0) {
        return '#38ba79';
      }
      return '#cdcdcd';
    });

  group.append('text')
    .attr('class', 'label')
    .attr('transform', d => `translate(${[ending + 35, y(d.end)]})`)
    .attr('dx', '.5em')
    .attr('dy', '.35em')
    .text(d => d.label)
    .call(wrapLongLabels, margins.right);

  const values = group.selectAll('g')
    .data(d => [{ y: d.start, x: starting }, { y: d.end, x: ending }])
    .enter().append('g');

  values.append('circle')
    .attr('class', 'dot')
    .attr('r', radius)
    .attr('cx', d => d.x)
    .attr('cy', d => y(d.y));

  values.append('text')
    .attr('class', 'value')
    .attr('x', d => d.x)
    .attr('y', d => y(d.y))
    .attr('dx', (d, i) => (i === 0 ? '-.5em' : '.5em'))
    .attr('dy', '.35em')
    .attr('text-anchor', (d, i) => (i === 0 ? 'end' : 'start'))
    .text(d => `${d.y}`);
}
